export default __webpack_public_path__ + "static/image7-73e430ae56df5fd1b3662fc80de06cbc.gif";